<template>
  <div class="UploadOSSFile" @click="onSelectFile">
    <input
      ref="file"
      type="file"
      :accept="accept"
      @change="onFileChange"
      v-show="false"
      :multiple="multiple"
    />
    <slot>
      <el-button type="primary" icon="ios-add" :disabled="disabled">
        {{ btnLabel }}
      </el-button>
    </slot>
    <slot name="note"></slot>
  </div>
</template>

<script>
export default {
  name: "UploadOSSFile",
  props: {
    note: {
      type: String,
    },
    format: {
      type: Array,
      default() {
        return [];
      },
    },
    accept: {
      type: String,
      default: "",
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    btnType: {
      default: "default",
    },
    btnLabel: {
      default: "选择文件",
    },
    maxSize: {
      type: Number, // 单位kb
      default: 0,
    },
    sizeError: {
      type: String,
      default: "文件大小超出限制",
    },
  },
  methods: {
    // on event
    onFileChange() {
      // console.log(this.$refs.file.files);
      const files = this.$refs.file.files;
      if (!files.length) return;
      const fileInfos = this.generateFiles(files);
      if (!this.checkFormat(fileInfos)) return;
      if (!this.checkSize(fileInfos)) return;
      this.upload(fileInfos);
    },
    onSelectFile() {
      if (this.disabled) return;
      this.$refs.file.value = null;
      this.$refs.file.click();
    },
    // other
    generateFiles(files) {
      const ret = [];
      for (const file of files) {
        ret.push({
          ext: file.name.split(".").pop() || "",
          file,
        });
      }
      return ret;
    },
    checkFormat(fileInfos) {
      if (!this.format.length) return true;
      for (const info of fileInfos) {
        if (!this.format.includes(info.ext)) {
          this.$error("不支持文件格式：" + info.ext);
          return false;
        }
      }
      return true;
    },
    checkSize(fileInfos) {
      if (this.maxSize <= 0) return true;
      for (const info of fileInfos) {
        const size = info.file.size / 1024;
        if (size > this.maxSize) {
          this.$error(this.sizeError);
          return false;
        }
      }
      return true;
    },
    async upload(fileInfos) {
      // console.log(fileInfos);
      // this.$store.commit("setShowFullModal", true);
      const ossParams = await this.$http.get(
        `/api/${this.$identity.getCommunityClientApiLetter()}/upload/signature`,
      );
      const uploads = fileInfos.map(fileInfo =>
        this.$actionTool.uploadFile(fileInfo.file, fileInfo.ext, ossParams),
      );
      let result;
      try {
        result = await Promise.all(uploads);
      } catch (e) {
        this.$error("OSS上传失败");
        console.error("OSS上传失败，错误消息:" + e);
      }
      // this.$store.commit("setShowFullModal", false);
      result.forEach(i => {
        this.$emit("onSuccess", i);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.UploadOSSFile {
  display: inline-block;
}
.note {
  color: #999;
  margin-left: 5px;
}
</style>
